import { useEffect, useRef } from "react";

/**
 * Cache-busting fix (Wes, Sep 17 2026): re-fetches on a fixed interval AND whenever the tab
 * regains focus/visibility, so no operational data (rep cards, call activity, deal status)
 * is ever more than `intervalMs` stale — max 60s per the P0 requirement.
 */
export function usePolling(fetchFn, intervalMs = 45000) {
  const fetchRef = useRef(fetchFn);
  fetchRef.current = fetchFn;

  useEffect(() => {
    const tick = () => fetchRef.current();
    const interval = setInterval(tick, intervalMs);
    const onFocus = () => tick();
    const onVisibility = () => { if (document.visibilityState === "visible") tick(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [intervalMs]);
}
